/**
 * /account/devices — the desktop wrapper around <DevicesPanel/>.
 *
 * Signed-out is handled HERE rather than by the panel, because the honest
 * answer differs by shell: on desktop a signed-out visitor gets a sign-in link
 * and can still browse; the panel itself has no business knowing that.
 */
import { useNavigate } from 'react-router-dom'
import { AppLayout } from '../components/AppLayout'
import { DevicesPanel } from '../components/DevicesPanel'
import { useIdentity } from '../lib/identity'
import { PressScale } from '../lib/PressScale'

export function Devices() {
  const navigate = useNavigate()
  const id = useIdentity()

  if (id.status === 'loading') {
    return (
      <AppLayout>
        <div className="mx-auto w-full max-w-[34rem] px-5 py-8 sm:px-6" aria-busy="true">
          <div className="skeleton h-7 w-56 rounded-sm" />
          <div className="mt-4 space-y-3">
            <div className="skeleton h-[68px] rounded-md" />
            <div className="skeleton h-[68px] rounded-md" />
          </div>
        </div>
      </AppLayout>
    )
  }

  if (!id.signedIn) {
    return (
      <AppLayout>
        <div className="mx-auto w-full max-w-[34rem] px-5 py-8 sm:px-6">
          <h1 className="font-serif text-2xl tracking-h2 text-navy-900">Devices &amp; sessions</h1>
          <p className="mt-3 text-sm leading-relaxed text-navy-500">
            Sign in to see the devices you’re signed in on and sign any of them out.
          </p>
          <div className="mt-6 flex flex-wrap gap-2.5">
            <PressScale feel="tap" className="btn-primary" onClick={() => navigate('/signin')}>
              Sign in
            </PressScale>
            <PressScale feel="tap" className="btn-ghost" onClick={() => navigate('/search')}>
              Browse the catalogue
            </PressScale>
          </div>
        </div>
      </AppLayout>
    )
  }

  return (
    <AppLayout>
      <DevicesPanel onBack={() => navigate('/')} />
    </AppLayout>
  )
}

export default Devices
